import { either } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import React from 'react';
import { useInputText } from 'utils/text';
import { cx } from '@linaria/core';
import { ZoomTextEnum } from 'modules/InputsManager/models/InputsViewerStore';
import { UI_STATES } from 'utils/uiStates/uiStates';
import { Spinner } from 'components/Spinner';
import { textInputView } from './styles';

/**
 * Fetch and render input text
 */
export function TextInputView({
  input,
  zoomTextLevel = ZoomTextEnum.M,
}: {
  input: CF.API.Inputs.TextInput;
  zoomTextLevel?: ZoomTextEnum;
}): JSX.Element | null {
  const text = useInputText(input);

  if (!input) return null;

  return (
    <>
      <div className={cx(textInputView, zoomTextLevel)} data-testid="TextInputView">
        <div>
          {pipe(
            text,
            either.map((txt) => {
              // eslint-disable-next-line react/no-array-index-key
              return txt.split('\n').map((p, idx) => <p key={idx}>{p}</p>);
            }),
            either.getOrElse(({ type }) =>
              type === UI_STATES.loading ? [<Spinner size={1.25} />] : [<p key="invalid">Invalid or unsupported text data.</p>],
            ),
          )}
        </div>
      </div>
    </>
  );
}
